export const StandardProjectModalTranslations = {
  en: {
    standardProjectModal: {
      projectName: "Performance Name",
      description: "Description",
      system: "System",
      voltages: "Voltages",
      technology: "Technology",
      refrigerant: "Refrigerant",
      capacities: "Capacities",
      heatExchanger: "Heat Exchanger",
      efficiency: "Efficiency",
      leavingWaterTemp: "Leaving Water Temperature",
      evaporatingTemperature: "Evaporating Temperature",
      enteringWaterTemp: "Entering Water Temperature",
      location: "Location",
      ambianceTemperature: "Ambient Temperature",
      amsl: "AMSL",
      runningCapacity: "Running Capacity",
      pressureDrop: "Pressure Drop",
      selectOption: "Please select an option",
      errors: "Please enter a valid value.",
      fluidType: "Fluid Type",
      fluidConcentration: "Fluid Concentration",
      water: "Water",
      propyleneGlycol: "Propylene Glycol",
    },
  },

  es: {
    standardProjectModal: {
      projectName: "Nombre de la hoja",
      description: "Descripción",
      system: "Sistema",
      voltages: "Voltajes",
      technology: "Tecnología",
      refrigerant: "Refrigerante",
      capacities: "Capacidades",
      heatExchanger: "Intercambiador de calor",
      efficiency: "Eficiencia",
      leavingWaterTemp: "Temperatura de salida del agua",
      evaporatingTemperature: "Temperatura de Evaporación",
      enteringWaterTemp: "Temperatura de entrada del agua",
      location: "Ubicación",
      ambianceTemperature: "Temperatura ambiente",
      amsl: "Altitud (AMSL)",
      runningCapacity: "Capacidad en operación",
      pressureDrop: "Caída de presión",

      selectOption: "Selecciona una opción",

      errors: "Por favor ingresa un valor válido.",

      fluidType: "Tipo de fluido",
      fluidConcentration: "Concentración del fluido",
      water: "Agua",
      propyleneGlycol: "Propilen Glicol",
    },
  },
};
